import React from 'react';

interface NavHomeIconProps {
  height?: string | number;
  width?: string | number;
  fill?: string;
}

const NavHomeIcon = ({ height = '19', width = '19', fill = '#BEBEBE' }: NavHomeIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99997 19H9.34615V13.0577H14.6538V19H18V10L12 5.48077L5.99997 10V19ZM4.5 20.5V9.25002L12 3.60582L19.5 9.25002V20.5H13.1538V14.5576H10.8461V20.5H4.5Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default NavHomeIcon;
